var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8274 24C29.3922 24 30.6608 22.7314 30.6608 21.1666V13.5331C30.6608 11.9683 29.3922 10.6996 27.8274 10.6996H19.8132H19.7498C18.2484 10.6573 17.4239 9.83262 17.3815 8.3313V8.26787V2.83349C17.3815 1.26873 16.1128 0 14.548 0H9.51548C7.9506 0 6.68198 1.26873 6.68198 2.83349V7.86611C6.68198 9.43087 7.9506 10.6996 9.51548 10.6996H14.9499H15.0132C16.5146 10.7419 17.3392 11.5666 17.3815 13.0679V13.1313V21.0398C17.3815 22.6679 18.7137 24 20.3419 24H27.8274ZM4.99035 10.6996C5.89961 10.6996 6.63963 11.4397 6.63963 12.3489V15.6899C6.63963 16.5992 5.89961 17.3392 4.99035 17.3392H1.64928C0.74002 17.3392 0 16.5992 0 15.6899V12.3489C0 11.4397 0.74002 10.6996 1.64928 10.6996H4.99035Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnots);
export default __webpack_public_path__ + "static/media/knots.c0ce5a46615468e4bf3af4836949ae3b.svg";
export { ForwardRef as ReactComponent };